// Mock data for Praise I AM Apologetics website

export const debates = [
  {
    id: 1,
    title: "The Great Morality Debate | Does Morality come from God?",
    opponent: "Mark Reid",
    topic: "Existence of God",
    date: "2024-12-18",
    videoUrl: "https://www.youtube.com/embed/n5NMadt9A34",
    description: "Examining the foundation of morality and whether objective moral values require God's existence.",
    thumbnail: "https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=800"
  },
  {
    id: 2,
    title: "The God Debate | God vs. Non-God Worldview (Which is True?)",
    opponent: "Grayson Hawk",
    topic: "Existence of God",
    date: "2024-12-10",
    videoUrl: "https://www.youtube.com/embed/U6nAn6RQCIQ",
    description: "A comprehensive worldview debate comparing Christian theism against non-theistic perspectives.",
    thumbnail: "https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=800"
  },
  {
    id: 3,
    title: "Christian Ethics VS RagingAtheist's Ethics",
    opponent: "Raging Atheist",
    topic: "Existence of God",
    date: "2024-11-30",
    videoUrl: "https://www.youtube.com/embed/s3XG8eUwPGk",
    description: "Debating the grounding of ethical systems between Christian and atheistic worldviews.",
    thumbnail: "https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=800"
  },
  {
    id: 4,
    title: "Does the Christian God Exist?",
    opponent: "Boi.",
    topic: "Existence of God",
    date: "2024-11-20",
    videoUrl: "https://www.youtube.com/embed/xnPxU8QfqRs",
    description: "Direct examination of arguments for and against the existence of the Christian God.",
    thumbnail: "https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=800"
  },
  {
    id: 5,
    title: "Does God Exist? Let's Debate",
    opponent: "Godless Girl",
    topic: "Existence of God",
    date: "2024-11-10",
    videoUrl: "https://www.youtube.com/embed/Qgib2rsmgJc",
    description: "A fundamental debate on the existence of God and the evidence for theism.",
    thumbnail: "https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=800"
  },
  {
    id: 6,
    title: "What is the Best Interpretation of James 2?",
    opponent: "Dan Chapa",
    topic: "Free Grace Debates",
    date: "2024-11-28",
    videoUrl: "https://www.youtube.com/embed/L7KAB8rdt4M",
    description: "Examining the proper interpretation of James 2 and its relationship to justification by faith alone.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800"
  },
  {
    id: 7,
    title: "Salvation Showdown | When Are You Saved?",
    opponent: "Sean Griffin",
    topic: "Free Grace Debates",
    date: "2024-11-15",
    videoUrl: "https://www.youtube.com/embed/SDA0OSFUg3g",
    description: "A comprehensive debate on the moment of salvation and what it means to be saved by grace through faith.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800"
  },
  {
    id: 8,
    title: "Is Unregenerate Man Able To Respond To The Gospel?",
    opponent: "TurretinFan",
    topic: "Free Grace Debates",
    date: "2024-10-22",
    videoUrl: "https://www.youtube.com/embed/hCLuxkHknrI",
    description: "Debating human ability and responsibility in responding to the gospel message.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800"
  },
  {
    id: 9,
    title: "Is Only Initial Justification Required to be Saved?",
    opponent: "Dan Chapa",
    topic: "Free Grace Debates",
    date: "2024-10-08",
    videoUrl: "https://www.youtube.com/embed/7dxy9ugpGCU",
    description: "Examining whether ongoing justification is necessary or if initial justification by faith is sufficient for salvation.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800"
  },
  {
    id: 10,
    title: "The Great Sanctification Debate",
    opponent: "TurretinFan",
    topic: "Free Grace Debates",
    date: "2024-09-20",
    videoUrl: "https://www.youtube.com/embed/EV2wbjRdQVo",
    description: "Exploring the relationship between sanctification and salvation, and whether holiness is required for eternal life.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800"
  },
  {
    id: 11,
    title: "Soteriology Showdown | What is the Best Exegesis of Hebrews 10?",
    opponent: "TurretinFan",
    topic: "Free Grace Debates",
    date: "2024-09-05",
    videoUrl: "https://www.youtube.com/embed/w7oRlEBr464",
    description: "A detailed exegetical debate on Hebrews 10 and its implications for the doctrine of salvation.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800"
  },
  {
    id: 12,
    title: "Is Jesus Yahweh?",
    opponent: "Sean Griffin",
    topic: "Trinity",
    date: "2024-10-15",
    videoUrl: "https://www.youtube.com/embed/l_tCdHOZ0zU",
    description: "Examining the biblical evidence for Jesus being identified as Yahweh, the God of the Old Testament.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 13,
    title: "Is God The Son The Angel of the Lord?",
    opponent: "Taylor Stewart",
    topic: "Trinity",
    date: "2024-10-12",
    videoUrl: "https://www.youtube.com/embed/CzdbC-nL4Dg",
    description: "Debating the identity of the Angel of the Lord and whether this refers to God the Son in the Old Testament.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 14,
    title: "Is Monarchianism Biblical?",
    opponent: "Caleb Purtscher",
    topic: "Trinity",
    date: "2024-10-08",
    videoUrl: "https://www.youtube.com/embed/oHImx4RN2Wg",
    description: "Examining Monarchianism and whether this view of God's nature is supported by Scripture.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 15,
    title: "The Deity of Christ Debate: God the Son or Not?",
    opponent: "A's Philosophy",
    topic: "Trinity",
    date: "2024-09-28",
    videoUrl: "https://www.youtube.com/embed/yVRyYs7rr-g",
    description: "A comprehensive debate on whether Jesus Christ is truly God the Son or merely a created being.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 16,
    title: "Deity of Christ Debate | Is Jesus God?",
    opponent: "Daniel",
    topic: "Trinity",
    date: "2024-09-20",
    videoUrl: "https://www.youtube.com/embed/hQeP39yGgS0",
    description: "Direct examination of the biblical case for the deity of Jesus Christ.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 17,
    title: "Is The Word The Father or The Son?",
    opponent: "Otis Lewis",
    topic: "Trinity",
    date: "2024-09-15",
    videoUrl: "https://www.youtube.com/embed/eMietCnek9k",
    description: "Debating the identity of 'The Word' in John 1 and whether this refers to the Father or the Son.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 18,
    title: "Is God One or Three Divine Persons?",
    opponent: "Andrew Griffin",
    topic: "Trinity",
    date: "2024-09-10",
    videoUrl: "https://www.youtube.com/embed/io1f3XgG0d8",
    description: "Examining the biblical doctrine of the Trinity and whether God exists as three distinct persons.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 19,
    title: "The Father and The Holy Spirit (Different Persons?)",
    opponent: "Caleb Purtscher",
    topic: "Trinity",
    date: "2024-09-05",
    videoUrl: "https://www.youtube.com/embed/qaELIzuF4yM",
    description: "Debating whether the Father and the Holy Spirit are distinct persons or the same person.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  },
  {
    id: 20,
    title: "Is Jesus God? | The Deity of Christ Debate",
    opponent: "Luke Jones",
    topic: "Trinity",
    date: "2024-08-28",
    videoUrl: "https://www.youtube.com/embed/8vXdxZZtsEc",
    description: "A thorough examination of the evidence for Jesus being fully God, equal with the Father.",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800"
  }, 
{
    id: 21,
    title: "DEBATE | The Bible and Slavery - Praise I AM vs. Taylor (Snake Was Right)",
    opponent: "Taylor (Snake Was Right)",
    topic: "Biblical Slavery",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/MeKfHH8xGoo",
    description: "Debate on the Bible and slavery.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 22,
    title: "DEBATE | Is Biblical Slavery Morally Good? - Praise I AM vs. James W",
    opponent: "James W",
    topic: "Biblical Slavery",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/W3Tf3s6svac",
    description: "Debate on whether biblical slavery is morally good.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 23,
    title: "DEBATE: Does the Old Testament Endorse Slavery? || Skylar & Dr Josh VS JIL & Praise",
    opponent: "Skylar & Dr Josh",
    topic: "Biblical Slavery",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/_xR6CYKNh54",
    description: "Does the Old Testament endorse slavery?",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 24,
    title: "GMan & Praise Vs Majors & Micheal | Biblical Slavery | Debate Podcast",
    opponent: "Majors & Micheal",
    topic: "Biblical Slavery",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/yaQSJMa7xac",
    description: "Biblical slavery debate podcast.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 25,
    title: "Biblical Slavery DEBATE | Dr Josh & SurisSkeptic vs Praise & JIL | Debate Podcast",
    opponent: "Dr Josh & SurisSkeptic",
    topic: "Biblical Slavery",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/zyv9ceBDUEY",
    description: "Biblical slavery debate podcast.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 26,
    title: "A Very Special Debate, Also It's About Slavery Again (Nadir v Praise)",
    opponent: "Nadir",
    topic: "Biblical Slavery",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/0HKCk7PkNtQ",
    description: "Nadir vs Praise debate on biblical slavery.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  }, 
  {
    id: 27,
    title: "DEBATE: Christianity VS Humanism || Praise VS Adam",
    opponent: "Adam",
    topic: "Random Topic Debates",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/8InXuG0g84k",
    description: "Christianity versus Humanism debate.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 28,
    title: "DEBATE: Soul Sleep Showdown - Praise I AM vs. Curious Christianity",
    opponent: "Curious Christianity",
    topic: "Random Topic Debates",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/qZqAStBAk3c",
    description: "Debate on soul sleep.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 29,
    title: "Debate on Aliens & Ufos! | Demons or Non-Human Intelligence? || Praise I AM vs. James W",
    opponent: "James W",
    topic: "Random Topic Debates",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/WFEZJzaJiXA",
    description: "Debate on aliens and UFOs.",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 30,
    title: "Is Atheism Reasonable? | Maddox & Praise Vs Amy & Brenda",
    opponent: "Amy & Brenda",
    topic: "Random Topic Debates",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/2EfyCbr5fs0",
    description: "Is atheism a reasonable worldview?",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 31,
    title: "DEBATE | What did the Cross Accomplish for Unbelievers? - Praise vs. DJ Keesee",
    opponent: "DJ Keesee",
    topic: "Random Topic Debates",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/_WUZ92iSkJ8",
    description: "What did the cross accomplish for unbelievers?",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  },
  {
    id: 32,
    title: "DEBATE: Is Unconditional Election Biblical? - JesusIsLord (JIL) vs. PraiseIAM",
    opponent: "JesusIsLord (JIL)",
    topic: "Random Topic Debates",
    date: "2024-01-01",
    videoUrl: "https://www.youtube.com/embed/2XyiV_TKeP8",
    description: "Is unconditional election biblical?",
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
  }
];

export const articles = [
  {
    id: 1,
    title: "The Free Grace Gospel: Faith Alone in Christ Alone",
    category: "Free Grace Theology",
    author: "Praise I AM Apologetics",
    date: "2024-12-01",
    excerpt: "An in-depth examination of the biblical basis for salvation by grace through faith alone, apart from works.",
    content: "Full article content here...",
    readTime: "12 min read"
  },
  {
    id: 2,
    title: "The Resurrection of Jesus: Historical Evidence",
    category: "Apologetics",
    author: "Praise I AM Apologetics",
    date: "2024-11-15",
    excerpt: "Examining the historical case for the bodily resurrection of Jesus Christ.",
    content: "Full article content here...",
    readTime: "15 min read"
  },
  {
    id: 3,
    title: "James 2: Faith Without Works?",
    category: "Free Grace Theology",
    author: "Praise I AM Apologetics",
    date: "2024-10-28",
    excerpt: "Understanding James 2 in light of justification by faith alone.",
    content: "Full article content here...",
    readTime: "10 min read"
  },
  {
    id: 4,
    title: "The Deity of Christ in the Gospel of John",
    category: "Apologetics",
    author: "Praise I AM Apologetics",
    date: "2024-10-05",
    excerpt: "Exploring John's explicit declarations of Jesus' divine nature.",
    content: "Full article content here...",
    readTime: "8 min read"
  },
  {
    id: 5,
    title: "Eternal Security: Once Saved, Always Saved",
    category: "Free Grace Theology",
    author: "Praise I AM Apologetics",
    date: "2024-09-20",
    excerpt: "Biblical evidence for the eternal security of the believer.",
    content: "Full article content here...",
    readTime: "14 min read"
  }
];

export const categories = [
  {
    name: "Existence of God",
    description: "Cosmological, teleological, and moral arguments for God's existence",
    icon: "Sparkles"
  },
  {
    name: "Deity of Christ",
    description: "Biblical evidence for the divine nature of Jesus Christ",
    icon: "Crown"
  },
  {
    name: "Trinity",
    description: "The biblical doctrine of the Triune God",
    icon: "Users"
  },
  {
    name: "Biblical Slavery",
    description: "Debates on the biblical and moral case against slavery in Scripture",
    icon: "Heart"
  },
  {
    name: "Biblical Reliability",
    description: "Manuscript evidence and textual criticism",
    icon: "BookOpen"
  },
  {
    name: "Salvation Clarified",
    description: "Understanding the Free Grace Gospel",
    icon: "Gift"
  },
  {
    name: "Responding to Atheism",
    description: "Answering atheist objections to Christianity",
    icon: "MessageSquare"
  },
  {
    name: "Responding to Islam",
    description: "Christian response to Islamic claims",
    icon: "Globe"
  },
  {
    name: "Responding to Catholicism",
    description: "Biblical examination of Catholic doctrines",
    icon: "Church"
  },
  {
    name: "Random Topic Debates",
      description: "Debates covering a variety of miscellaneous topics",
      icon: "Shuffle"
    }
];

export const freeGraceTopics = [
  {
    title: "What Is the Free Grace Gospel?",
    description: "Understanding salvation as a free, irrevocable gift received by faith alone in Christ alone."
  },
  {
    title: "Faith Alone vs Lordship Salvation",
    description: "Examining the key differences between Free Grace and Lordship Salvation theology."
  },
  {
    title: "Eternal Life: Gift vs Reward",
    description: "Distinguishing between the free gift of eternal life and rewards for faithful service."
  },
  {
    title: "Justification vs Sanctification",
    description: "Understanding the distinction between positional righteousness and progressive holiness."
  },
  {
    title: "Assurance of Salvation",
    description: "How believers can have certainty of their eternal destiny."
  },
  {
    title: "Inheritance, Crowns, and Rewards",
    description: "What Scripture teaches about rewards for faithful disciples."
  }
];

export const resources = [
  {
    title: "The Gospel Under Siege",
    author: "Zane Hodges",
    type: "Book",
    description: "A study on faith and works in salvation"
  },
  {
    title: "Absolutely Free!",
    author: "Zane Hodges",
    type: "Book",
    description: "A biblical reply to Lordship Salvation"
  },
  {
    title: "The Grace Awakening",
    author: "Charles Swindoll",
    type: "Book",
    description: "Believing in grace is one thing, living it is another"
  },
  {
    title: "Greek Interlinear Bible",
    author: "Various",
    type: "Study Tool",
    description: "Essential for word studies and exegesis"
  }
];

export const mediaPlaylists = [
  {
    title: "Apologetics Debates",
    count: 15,
    thumbnail: "https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=400"
  },
  {
    title: "Free Grace Theology",
    count: 23,
    thumbnail: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=400"
  },
  {
    title: "Prophecy & Eschatology",
    count: 12,
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=400"
  },
  {
    title: "Short Clips & Highlights",
    count: 45,
    thumbnail: "https://images.unsplash.com/photo-1499728603263-13726abce5fd?w=400"
  }
];
